import { render, staticRenderFns } from "./other-business.vue?vue&type=template&id=2e8f047c&scoped=true&"
import script from "./other-business.vue?vue&type=script&lang=js&"
export * from "./other-business.vue?vue&type=script&lang=js&"
import style0 from "./other-business.vue?vue&type=style&index=0&id=2e8f047c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8f047c",
  null
  
)

export default component.exports